function containsSmartName (text: string): boolean {
  return (text.match(/\w*<\w+\/>\w*/) != null);
}

const SmartNameSupport = {
  containsSmartName
};

export default SmartNameSupport;
